import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The data warehouse can link to data in your Azure storage accounts.`}</p>
    <ol>
      <li parentName="ol">{`Create an Azure storage account`}</li>
      <li parentName="ol">{`Create a blob container`}</li>
      <li parentName="ol">{`Upload data and link to PostHog`}</li>
    </ol>
    <h2 {...{
      "id": "step-1-create-an-azure-storage-account"
    }}>{`Step 1: Create an Azure storage account`}</h2>
    <p>{`Firstly, log into Azure and go to Storage Accounts, then create a storage account by following `}<a parentName="p" {...{
        "href": "https://learn.microsoft.com/en-us/azure/storage/common/storage-account-create?tabs=azure-portal#create-a-storage-account"
      }}>{`this Azure guide`}</a>{`.`}</p>
    <h2 {...{
      "id": "step-2-create-a-blob-container"
    }}>{`Step 2: Create a blob container`}</h2>
    <p>{`Once the storage account has been created, follow `}<a parentName="p" {...{
        "href": "https://learn.microsoft.com/en-us/azure/storage/blobs/storage-quickstart-blobs-portal#create-a-container"
      }}>{`this guide to create a blob container`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Screenshot_2024_07_18_at_11_08_05_cf44b9340b.png",
        "alt": "container creation"
      }}></img></p>
    <h2 {...{
      "id": "step-3-upload-data-and-link-to-posthog"
    }}>{`Step 3: Upload data and link to PostHog`}</h2>
    <p><a parentName="p" {...{
        "href": "https://learn.microsoft.com/en-us/azure/storage/blobs/storage-quickstart-blobs-portal#upload-a-block-blob"
      }}>{`Upload your data to the newly created container`}</a>{`, Parquet files are the recommended format, but the connector also works with JSON and CSVs too. `}</p>
    <p>{`Find the newly created file via the storage browser menu item. Once found, open the details and copy URL property. We need it to link the file in PostHog.`}</p>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Screenshot_2024_07_15_at_17_59_09_2f888aaa2f.png",
        "alt": "copy blob file"
      }}></img></p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select Azure from the self managed section`}</li>
      <li parentName="ol">{`Enter a name for your dataset and paste the copied URL into the "Files URL pattern" box`}</li>
      <li parentName="ol">{`Select the correct format for your data`}</li>
      <li parentName="ol">{`Enter the storage account name (this is name of the storage account you created in step 1)`}</li>
      <li parentName="ol">{`Find and paste your storage account key - you can use `}<a parentName="li" {...{
          "href": "https://learn.microsoft.com/en-us/azure/storage/common/storage-account-keys-manage?tabs=azure-portal#view-account-access-keys"
        }}>{`this Azure doc`}</a>{` to view your access keys`}</li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Screenshot_2024_07_15_at_18_10_06_f93fadf82b.png",
        "alt": "linking your data in posthog"
      }}></img></p>
    <p>{`That's it! You should be able to query the data from the PostHog SQL editor.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      